<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div class="mt-4">
      <b-row>
        <b-col sm="12" md="6" lg="6" class="m-0 p-0">
          <b-card sm="6" class="m-1 p-1">
            <div slot="header">
              <strong>Current Scheduled Reports</strong>
            </div>

            <b-table :items="scheduledReports" :fields="currentReportNameFields" hover striped bordered small :current-page="currentPage" :per-page="perPage" show-empty>
              <template v-slot:cell(SCHEDULE)="data">
                <ul class="fa-ul">
                  <li v-for="item in data.value"><i class="fa-li fa fa-check-square"></i> <label style="width:150px">{{item.date}}{{ SchedulerNth(data.date)}} Day of the month</label>  <span style="margin-right:20px;"></span>    <label v-for="time in item.times" style="margin-right:20px;"> [<strong>{{time}}</strong> hrs]   </label> </li>
                </ul>
              </template>
            </b-table>
          </b-card>

        </b-col>
        <b-col sm="12" md="6" lg="6" class="m-0 p-0">
          <b-card sm="6" class="m-1 p-1">
            <div slot="header">
              <strong>mGauge Usage</strong>
            </div>
            <b-table :items="mGaugeUsage" :fields="mGaugeUsageFields" hover striped bordered small :current-page="currentPage" :per-page="perPage" show-empty>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6" lg="6" class="m-0 p-0">

        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'
import { setTimeout } from 'timers'
Vue.use(Vue2Filters)
export default {
  components: {
    loading
  },
  created () {
    var self = this
    setTimeout(function () {
      self.initLoad = true
      self.boolLoading = false
    }, 3500)
    self.createUsageSummaryTable()
    self.getUsageSummary()
    this.date = moment(new Date())
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      initLoad: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      IAceptCheck: false,
      Name: '',
      date: moment(new Date()),
      currentReportNameFields: [
        { key: 'TITLE', label: 'Title', sortable: true },
        { key: 'SCHEDULE', label: 'Schedule', sortable: true }
      ],
      mGaugeUsage: [],
      mGaugeUsageFields: [
        { key: 'Title', label: 'Title', sortable: true },
        { key: 'Total', label: 'Total', sortable: true }
      ],
      scheduledReports: [],
      contractedTotal: 0,
      billabletTotal: 0,
      overageTotal: 0,
      availableTotal: 0,
      currentPage: 1,
      perPage: 15,
      totalRows: 0
    }
  },
  methods: {
    SchedulerNth (val) {
      let d = parseInt(val + '')
      if (d > 3 && d < 21) {
        return 'th'
      }
      switch (d % 10) {
        case 1:
          return 'st'
        case 2:
          return 'nd'
        case 3:
          return 'rd'
        default:
          return 'th'
      }
    },
    createUsageSummaryTable () {
      this.mGaugeUsage = [
        { Title: 'Active Scheduled', Total: this.scheduledReports.length },
        { Title: 'Contracted', Total: this.contractedTotal },
        { Title: 'Available', Total: this.availableTotal },
        { Title: 'Billable Used', Total: this.billabletTotal },
        { Title: 'Overage', Total: this.overageTotal }
      ]
    },
    getUsageSummary () {
      this.boolLoading = true
      axios.get('/api/mgauge/getusagesummary')
        .then(response => {
          this.boolLoading = false
          this.initLoad = false
          this.scheduledReports = response.data.scheduledReports
          this.contractedTotal = response.data.contractedTotal
          this.availableTotal = response.data.availableTotal
          this.billabletTotal = response.data.billabletTotal
          this.overageTotal = response.data.overageTotal
          this.createUsageSummaryTable()
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    }

  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
    this.initLoad = false
  }
}
</script>
<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }
  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px 0.3rem;
  }
  .table-xtra-condensed.table {
    margin-bottom: initial !important;
  }
  body {
    background-color: initial;
  }
</style>



// WEBPACK FOOTER //
// src/views/mGaugeUsageSummary.vue